export const userActionsLabels = {
    USER_LOGIN:'USER_LOGIN',
    USER_LOGOUT:'USER_LOGOUT'
}